import { Component } from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';

const SearchBoxElement = styled.div`
  font-size: ${(props: any) => getFontSize(props)};
  display: flex;
  align-items: center;
  background-color: ${(props: any) => (props.size === 'large' ? props.theme.vars.newColor.lightGS2 : 'none')};
  border-radius: ${(props: any) => (props.size === 'campaign-list' ? '0px' : '5px')};
  padding: ${(props: any) => (props.size === 'large' ? '20px' : props.size === 'campaign-list' ? '6px' : '0px')};
  width: ${(props: any) => props.width}px;
  border: 1px solid ${(props: any) => (props.size === 'campaign-list' ? 'lightgrey' : 'none')};
  padding-left: ${(props: any) => (props.size === 'campaign-list' ? '10px' : '0px')};
` as any;

const InputElement = styled.input`
  font-size: ${(props: any) => getFontSize(props)};
  border: none;
  margin-left: 10px;
  outline: none;
  color: #1a1d1f;
  width: ${(props: any) => (props.size === 'large' || props.size === 'campaign-list' ? '100%' : '80px')};
  background-color: transparent;

  &::placeholder {
    color: ${(props: any) => getColor(props)};
    font-weight: 300;
  }
` as any;

export type SearchBoxVariation = 'normal' | 'primary' | 'secondary';
export type SearchBoxSize = 'small' | 'campaign-list' | 'medium' | 'large';

export interface IProps {
  /** 'normal' (default) | 'primary' | 'secondary' */
  variation?: SearchBoxVariation;
  /** 'small' (default) | 'medium' | 'large' */
  size?: SearchBoxSize;
  width?: number;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  name?: string;
}

export class SearchBox extends Component<IProps> {
  public input: JSX.Element;

  public render() {
    return (
      <SearchBoxElement size={this.props.size} width={this.props.width}>
        <Icon icon="search" color={getColor(this.props)} />
        <InputElement
          ref={this.ref}
          placeholder={this.props.placeholder || 'Search...'}
          size={this.props.size}
          onChange={this.handleInputChanged}
          value={this.props.value}
          variation={this.props.variation}
          name={this.props.name}
          aria-label="Search"
        />
      </SearchBoxElement>
    );
  }

  private handleInputChanged = e => {
    if (this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  };

  private ref = (el: JSX.Element) => {
    this.input = el;
  };
}

function getFontSize(props) {
  switch (props.size) {
    default:
    case 'small':
      return '14px';
    case 'campaign-list':
      return '15px';
    case 'medium':
      return '20px';
    case 'large':
      return '24px';
  }
}

function getColor(props: any) {
  return props.variation === 'secondary' ? '#93ABBC' : 'lightgray';
}
